import { RoutingUtilitiesService } from '../_services/routingUtlities.service';

let loaderService: RoutingUtilitiesService | null = null;

export function setRoutingLoaderService(service: RoutingUtilitiesService) {
  loaderService = service;
}

export function loadActivityModule() {
  if (!loaderService) {
    console.error('ActivityLoaderService not initialized');
    // Fallback to legacy
    return import('../../activityV3/activity.module').then((m) => m.ActivityModule);
  }

  return loaderService.loadModuleActivityModule();
}
